import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import TextField from "../Reusable/TextField";

const Configuration = (props: any) => {
  const { handleCreate, isLoading, selectedType, setSelectedType, data } =
    props;

  const { control, handleSubmit, setError, setValue } = useForm({});

  const { data: types = [] } = useGetHook({
    queryKey: ["types"],
    url: APIS.TYPES,
    params: {},
  });

  useEffect(() => {
    if (types.length > 0 && !selectedType) {
      setSelectedType(types[0].value);
    }
  }, [types, selectedType, setSelectedType]);

  const stringifyData = JSON.stringify(data);

  useEffect(() => {
    if (selectedType) {
      const key = formatKey(selectedType);
      setValue(`prefix_${key}`, data[0]?.prefix ?? "");
      setValue(`postfix_${key}`, data[0]?.postfix ?? "");
      setValue(`expression_${key}`, data[0]?.expression ?? "");
    }
  }, [selectedType, stringifyData, data, setValue]);

  const formatKey = (label: string) => label.replace(/\s+/g, "_");

  const onSubmit = (formData: any) => {
    if (!selectedType) return;

    const key = formatKey(selectedType);

    const result = {
      type: selectedType,
      prefix: formData?.[`prefix_${key}`] || "",
      postfix: formData?.[`postfix_${key}`] || "",
      expression: formData?.[`expression_${key}`] || "",
    };

    handleCreate(result);
  };

  const output = data[0]?.replacements
    ? Object.entries(data[0]?.replacements).map(
        ([key, value]) => `${key}: ${value}`
      )
    : [];

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={onSubmit}
        setError={setError}
        buttonLabel="Submit"
        isLoading={isLoading}
        disabled={false}
      >
        <div className={tw`px-4 pt-4`}>
          <div className={tw`flex flex-wrap   gap-2 mb-6`}>
            {types.map((type: any) => {
              const isActive = selectedType === type.value;
              return (
                <button
                  key={type.value}
                  type="button"
                  className={tw`px-3 py-1.5  text-sm focus:outline-none ${
                    isActive
                      ? "bg-primary text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                  onClick={() => setSelectedType(type.value)}
                >
                  {type.name}
                </button>
              );
            })}
          </div>

          {/* Show Form for Selected Type */}
          {selectedType && (
            <div className={tw`grid grid-cols-3 gap-x-4`}>
              <TextField
                label={`${selectedType} Prefix`}
                control={control}
                name={`prefix_${formatKey(selectedType)}`}
              />
              <TextField
                label={`${selectedType} Expression`}
                control={control}
                name={`expression_${formatKey(selectedType)}`}
              />
              <TextField
                label={`${selectedType} Postfix`}
                control={control}
                name={`postfix_${formatKey(selectedType)}`}
              />
            </div>
          )}
        </div>
      </FormLayout>
      {output?.length > 0 ? (
        <>
          <p
            className={tw`font-semibold  text-center
        `}
          >
            Identifiers
          </p>
          <div className={tw`grid grid-cols-6 border p-2 border-gray-500`}>
            {output?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        </>
      ) : null}
    </>
  );
};

export default Configuration;
